
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import SplashPage from '../pages/splash/page';
import LanguagePage from '../pages/language/page';
import LoginPage from '../pages/auth/login/page';
import NotFound from '../pages/NotFound';
import FlightsPage from '../pages/flights/page';
import FlightResultsPage from '../pages/flights/results/page';
import BusesPage from '../pages/buses/page';
import HotelsPage from '../pages/hotels/page';
import CarsPage from '../pages/cars/page';
import MyTripsPage from '../pages/my-trips/page';
import ProfilePage from '../pages/profile/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SplashPage />
  },
  {
    path: '/language',
    element: <LanguagePage />
  },
  {
    path: '/auth/login',
    element: <LoginPage />
  },
  {
    path: '/home',
    element: <HomePage />
  },
  {
    path: '/flights',
    element: <FlightsPage />
  },
  {
    path: '/flights/results',
    element: <FlightResultsPage />
  },
  {
    path: '/buses',
    element: <BusesPage />
  },
  {
    path: '/hotels',
    element: <HotelsPage />
  },
  {
    path: '/cars',
    element: <CarsPage />
  },
  {
    path: '/my-trips',
    element: <MyTripsPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
